import { render, staticRenderFns } from "./CodeModule.vue?vue&type=template&id=34c0f0ed&scoped=true"
import script from "./CodeModule.vue?vue&type=script&lang=js"
export * from "./CodeModule.vue?vue&type=script&lang=js"
import style0 from "./CodeModule.vue?vue&type=style&index=0&id=34c0f0ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c0f0ed",
  null
  
)

export default component.exports